import api from '../api/index'

// 轮播图
export  const getBannerList = () => {
    return api.get('/portal/home/carousel/list')
}
// 最新新闻
export const getNewsTop = () => {
    return api.get('/portal/home/news/top')

}
// 最新活动
export const getActivityTop = () => {
    return api.get('/portal/home/latestActivety/top5')
}

export const login = (params) => {
    return api.post(`/login`, params)
}

export const register = (params) => {
    return api.post(`/user/register`,params);
}

export const captchaImage = () => {
    return api.get(`/captchaImage`);
}

// 提交签名
export const signaTure = (params) => {
    return api.post(`/common/user/signature`, params);
}
// 查询签名
export const getSignUrl = (userid) => {
    return api.get(`/common/user/query/signature/${userid}`);
}

